import { Link } from "react-router-dom";

export const Logo = ({ to = "/", light }) => (
  <Link to={to} className="flex items-center gap-2 group" data-testid="logo-link">
    <span className="relative h-9 w-9 rounded-xl bg-[#1E3A8A] grid place-items-center overflow-hidden">
      <span className="absolute -right-2 -bottom-2 h-5 w-5 rounded-full bg-[#E07A5F] transition-transform duration-300 group-hover:scale-150" />
      <span className="relative font-display font-bold text-white text-lg">B</span>
    </span>
    <span className={`font-display text-xl font-semibold tracking-tight ${light ? "text-white" : "text-[#0F172A]"}`}>
      Burocrazy
    </span>
  </Link>
);
